import styled, { css } from 'styled-components';
import { ReactSVG } from 'react-svg';
import React from 'react';

interface ISVGIcon {
  icon: any;
  size?: '16px' | '24px' | '32px' | '48px' | '64px' | string;
}

interface ISVGIconStyle {
  size?: '16px' | '24px' | '32px' | '48px' | '64px' | string;
}

const SVGIconStyle = styled.div<ISVGIconStyle>`
  ${(props) =>
    props.size &&
    css`
      width: ${props.size};
      min-width: ${props.size};
      height: ${props.size};

      svg {
        width: ${props.size};
        min-width: ${props.size};
        height: ${props.size};
      }
    `}
  path {
    fill: ${(props) => props.theme.primary.primary50};
  }
`;

export const SVGIcon: React.FC<ISVGIcon> = (props: ISVGIcon) => {
  const { icon, size } = props;
  return (
    <SVGIconStyle size={size}>
      <ReactSVG src={icon} />
    </SVGIconStyle>
  );
};

export default SVGIcon;
